import Vue from "vue";
import VueRouter from "vue-router";
const TermsOfUse = () =>
  import(/* webpackChunkName: "termsOfUse" */ "@/views/TermsOfUse.vue");
const PrivacyPolicy = () =>
  import(/* webpackChunkName: "privacyPolicy" */ "@/views/PrivacyPolicy.vue");
const Home = () => import(/* webpackChunkName: "home" */ "@/views/Home.vue");
const Favorites = () =>
  import(/* webpackChunkName: "favorites" */ "@/views/Favorites.vue");
const Search = () =>
  import(/* webpackChunkName: "search" */ "@/views/Search.vue");
const PurpleSpoon = () =>
  import(/* webpackChunkName: "pueple_spoon" */ "@/views/PurpleSpoon.vue");
const Shop = () => import(/* webpackChunkName: "shop" */ "@/views/Shop.vue");
const Article = () =>
  import(/* webpackChunkName: "article" */ "@/views/Article.vue");

Vue.use(VueRouter);

const routes = [
  {
    path: "/:locale/home",
    name: "home",
    component: Home,
  },
  {
    path: "/:locale/privacy-policy",
    name: "privacyPolicy",
    component: PrivacyPolicy,
  },
  {
    path: "/:locale/search",
    name: "search",
    component: Search,
  },
  {
    path: "/:locale/purple_spoon",
    name: "purpleSpoon",
    component: PurpleSpoon,
  },
  {
    path: "/:locale/favorites",
    name: "favorites",
    component: Favorites,
  },
  {
    path: "/:locale/terms-of-use",
    name: "termsOfUse",
    component: TermsOfUse,
  },
  {
    path: "/:locale/shops/:shop-id",
    name: "shop",
    component: Shop,
  },
  {
    path: "/:locale/articles/:articleId",
    name: "article",
    component: Article,
  },
  {
    path: "/articles/:articleId",
    name: "articleWithNoLocale",
    redirect: (to) => {
      const language =
        (window.navigator.languages && window.navigator.languages[0]) ||
        window.navigator.language ||
        window.navigator.userLanguage ||
        window.navigator.browserLanguage;
      return {
        name: "article",
        params: {
          locale: language.substr(0, 2),
          articleId: to.params.articleId
        },
      };
    },
  },
  {
    path: "*",
    name: "notFound",
    redirect: () => {
      const language =
        (window.navigator.languages && window.navigator.languages[0]) ||
        window.navigator.language ||
        window.navigator.userLanguage ||
        window.navigator.browserLanguage;
      return {
        name: "home",
        params: {
          locale: language.substr(0, 2),
        },
      };
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
